import { render, staticRenderFns } from "./OrganizationEditProfileView.vue?vue&type=template&id=68ae1f7e&"
import script from "./OrganizationEditProfileView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationEditProfileView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ae1f7e')) {
      api.createRecord('68ae1f7e', component.options)
    } else {
      api.reload('68ae1f7e', component.options)
    }
    module.hot.accept("./OrganizationEditProfileView.vue?vue&type=template&id=68ae1f7e&", function () {
      api.rerender('68ae1f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/profile/OrganizationEditProfileView.vue"
export default component.exports